import { CustomerStory } from "../classes";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// initState
const initialState: customerStoriesInterface = {
  getInfo: false, //false면 안 받음, true면 받음
  customerStories: [],
};

// interface
interface customerStoriesInterface {
  getInfo: boolean;
  customerStories: CustomerStory[];
}

export const customerStoriesSlice = createSlice({
  name: "customer_stories",
  initialState,
  reducers: {
    setCustomerStories: (state, action: PayloadAction<customerStoriesInterface>) => {
      if (action.payload.getInfo !== undefined) state.getInfo = action.payload.getInfo;
      if (action.payload.customerStories !== undefined)
        state.customerStories = action.payload.customerStories;
    },
  },
});

export const { setCustomerStories } = customerStoriesSlice.actions;
export const customerStoriesReducer = customerStoriesSlice.reducer;
